import { render, staticRenderFns } from "./ShareInfo.vue?vue&type=template&id=523f89e3&"
import script from "./ShareInfo.vue?vue&type=script&lang=js&"
export * from "./ShareInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShareInfo.vue?vue&type=style&index=0&id=523f89e3&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523f89e3')) {
      api.createRecord('523f89e3', component.options)
    } else {
      api.reload('523f89e3', component.options)
    }
    module.hot.accept("./ShareInfo.vue?vue&type=template&id=523f89e3&", function () {
      api.rerender('523f89e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShareInfo.vue"
export default component.exports